import { render, staticRenderFns } from "./IvTypesPanel.vue?vue&type=template&id=44fa35da&scoped=true&"
import script from "./IvTypesPanel.vue?vue&type=script&lang=js&"
export * from "./IvTypesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa35da",
  null
  
)

export default component.exports